export interface ColorsInterface {
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
  color6: string;
  color7: string;
  color8: string;
  color9: string;
  color10: string;
  color11: string;
  color12: string;
  color13: string;
  color14: string;
  color15: string;
  color16: string;
  color17: string;
  color18: string;
  color19: string;
  color20: string;
  color21: string;
  color22: string;
  color23: string;
  color24: string;
  color25: string;
  color26: string;
  color27: string;
  color28: string;
  color29: string;
  color30: string;
  color31: string;
  color32: string;
  color33: string;
  color34: string;
  color35: string;
  color36: string;
  color37: string;
  color38: string;
  color39: string;
}

const colors: ColorsInterface = {
  color1: '#ffffff',
  color2: '#ffffff',
  color3: '#484848',
  color4: '#484848',
  color5: '#1b1b32',
  color6: '#301f38',
  color7: '#25132d',
  color8: '#ffffffe5',
  color9: '#ffffffcc',
  color10: '#eb5ca3',
  color11: '#7c3e85',
  color12: '#c299c5',
  color13: '#ebebeb',
  color14: 'white',
  color15: '#adadad',
  color16: '#ffffff26',
  color17: 'black',
  color18: '#ffffff33',
  color19: '#ffffff14',
  color20: '#ffffff66',
  color21: '#5e3271',
  color22: '#ffffff99',
  color23: '#25132d80',
  color24: '#00000040',
  color25: '#858585',
  color26: '#af9de0',
  color27: '#25132db2',
  color28: '#4f110d',
  color29: '#f25f55',
  color30: '#49b980',
  color31: '#003d22',
  color32: '#d92d20',
  color33: '#912018',
  color34: '#f05348b2',
  color35: '#129d60',
  color36: '#027a48',
  color37: '#12b76ab2',
  color38: '#00000033',
  color39: '#d6d6d6'
};

export default function getColors() {
  return colors;
}
